import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import EmptyData from "../../Global/EmptyData";
import useMostSpentCustomer from "./useMostSpentCustomer";
import SendExcelData from "../../Admin/OrderList/SendExcelData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";

const MostSpentCustomer = () => {
  const {
    date,
    isLoading,
    isFetching,
    showEditModal,
    isExcelLinkSend,
    paginationOptions,
    mostSpentCustomerList,
    mostSpentCustomerState,
    handleMostSpentCustomerExcelDownload,
    updateMostSpentCustomerFields,
    handleEditColumnsClick,
    handleDateRangeChange,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    sendExcelData,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  } = useMostSpentCustomer();
  return (
    <>
      <HeadingGroup title="Most Spent Customer" className={`pro-mb-4`}>
        <div className="col dropdown-filter pro-d-flex">
          <button
            className={`pro-btn pro-btn-outline-primary no-wrap pro-items-center pro-ms-3`}
            type="submit"
            onClick={handleMostSpentCustomerExcelDownload}
          >
            <span className="material-symbols-outlined x4">download</span>
            <span>{`Most Spent Customer Data`}</span>
          </button>
        </div>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={
            mostSpentCustomerState?.search === "" ? false : true
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: mostSpentCustomerState?.search }}
          handleActionClick={handleEditColumnsClick}
          searchable={false}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {mostSpentCustomerList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={mostSpentCustomerList?.data?.result || []}
            uniqueID={"id"}
            fields={mostSpentCustomerList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={mostSpentCustomerState?.clearSelection}
            perpage={mostSpentCustomerState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {mostSpentCustomerList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={mostSpentCustomerState?.currentPage}
            totalPageCount={Math.ceil(
              mostSpentCustomerList?.data.total_count /
                mostSpentCustomerState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === mostSpentCustomerState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={mostSpentCustomerList?.data?.fields || []}
              moduleId={mostSpentCustomerList?.data?.module_id}
              updateData={updateMostSpentCustomerFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={mostSpentCustomerState.mostSpentCustomerExcelSendModal}
          handleClose={handleMostSpentCustomerExcelDownload}
          title={`Send Excel Download Link`}
          backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isBestSeller
              handleCloseModal={modalClose}
              sendExcelData={sendExcelData}
              isExcelLinkSend={isExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default MostSpentCustomer;
